import React, {} from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { translate as t } from 'hooks/useTranslations';
import CommonLayout from 'views/App/Portal/_layouts/CommonLayout';
import { ReactComponent as NoSolutionSelectedImage } from '../../_assets/NoSolutionSelected.svg';

const NoSolutionSelected: React.FC = () => {
    return (
        <Box sx={{ p: 5, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
            <NoSolutionSelectedImage />
            <Typography variant='subtitleLg'>{t('manageSolutions.emptyState.title')}</Typography>
            <Typography variant='bodyMd'>{t('manageSolutions.emptyState.description')}</Typography>
        </Box>

    );
};

export default NoSolutionSelected;
